// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_cr-0";